if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      // Initialize button adjustment logic
      this.initButtonAdjustment();

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    initButtonAdjustment() {
      // Initialize MutationObserver to watch for class changes
      this.setupClassObserver();
    }

    setupClassObserver() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            this.adjustButtonPositions();
          }
        });
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class']
      });

      // Initial adjustment
      this.adjustButtonPositions();
    }

    adjustButtonPositions() {
      const bonLoyaltyBtn = document.getElementById('bon-loyalty-btn');
      const chatButton = document.getElementById('chat-button');

      if (!bonLoyaltyBtn && !chatButton) return;

      const isPanelHiddenByClass = this.classList.contains('sticky-atc-panel--out');
      const isScrolledToBottom = document.body.classList.contains('scrolled-to-bottom');
      const isPanelVisible = !isPanelHiddenByClass && !isScrolledToBottom;

      const panelHeight = this.offsetHeight || 80; // Default to 80px if height not available
      const newBottom = isPanelVisible ? `${panelHeight + 5}px` : '20px';

      // Apply smooth transition
      [bonLoyaltyBtn, chatButton].forEach(button => {
        if (button) {
          button.style.transition = 'bottom 0.3s ease';
          button.style.bottom = newBottom;
        }
      });
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
        // Adjust button positions after class changes
        setTimeout(() => this.adjustButtonPositions(), 50);
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);

      // Short-page fallback (mobile only). On pages with little content the main
      // ATC never scrolls out of view, so the IntersectionObserver fires only once
      // (form visible) and the panel would stay hidden — the sticky ATC never shows.
      // Force it visible so the mobile sticky ATC is always reachable.
      this.ensureVisibleOnShortPage();
      window.addEventListener('resize', () => this.ensureVisibleOnShortPage());
    }

    /**
     * Mobile: reveal the sticky panel when the page is too short for the main ATC
     * to ever scroll past the top of the viewport. Desktop is left untouched.
     */
    ensureVisibleOnShortPage() {
      if (theme.mediaMatches.md || !this.productForm) return;
      const rect = this.productForm.getBoundingClientRect();
      const formBottomDoc = rect.bottom + window.scrollY;
      const maxScrollY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      // If even at maximum scroll the form bottom stays below the viewport top,
      // the observer can never flip → show the sticky ATC.
      if (formBottomDoc - maxScrollY > 0) {
        this.classList.remove('sticky-atc-panel--out');
        setTimeout(() => this.adjustButtonPositions(), 50);
      }
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      const wasScrolledToBottom = document.body.classList.contains('scrolled-to-bottom');
      const isScrolledToBottom = window.scrollY + window.innerHeight + 100 > document.body.scrollHeight;

      document.body.classList.toggle('scrolled-to-bottom', isScrolledToBottom);

      // If scroll state changed, update button positions
      if (wasScrolledToBottom !== isScrolledToBottom) {
        const stickyPanels = document.querySelectorAll('sticky-atc-panel');
        stickyPanels.forEach(panel => {
          if (panel.adjustButtonPositions) {
            setTimeout(() => panel.adjustButtonPositions(), 50);
          }
        });
      }
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
